import { ThunkType } from "../../../../core/store/reducers";
import { setData } from "../exchangeMemberDataSlice";
import getExchangeMembersDataApi from "../api/getExchangeMembersData";

export const loadReport = (): ThunkType => async (dispatch, getStore) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const user = store.data.auth.current.user;
  const { filter } = store.ux.reports.exchmembers;


  const pagedTrades = await dispatch(getExchangeMembersDataApi(user, filter));

  dispatch(setData(pagedTrades || []));
};
